import { guid } from "@buildwithflux/shared";
import { addUidToFileName, bucketSubFolders } from "./naming";
function createDocumentAssetFilename(name) {
    return `${bucketSubFolders.documentAssets}/${addUidToFileName(name)}`;
}
export function buildSymbolAsset(asset) {
    const storageName = createDocumentAssetFilename(asset.filename);
    const assetUid = guid();
    const createdAsset = {
        fileType: "svg",
        is3dModel: false,
        isDefault: true,
        isFootprint: false,
        isPcbBoardShape: false,
        isThumbnail: true,
        label: asset.filename,
        name: asset.filename.split(".").shift() || "",
        rawName: asset.filename,
        storageName,
        uid: assetUid,
    };
    if (asset.associatedSymbol) {
        createdAsset.associatedSymbol = asset.associatedSymbol;
    }
    return createdAsset;
}
export function buildFootprintAsset(asset) {
    const storageName = createDocumentAssetFilename(asset.filename);
    const assetUid = guid();
    return {
        fileType: "kicad_mod",
        is3dModel: false,
        isDefault: false,
        isFootprint: true,
        isPcbBoardShape: false,
        isThumbnail: false,
        label: asset.filename,
        name: (asset.filename.split(".").shift() || "") + " Footprint",
        rawName: asset.filename,
        storageName,
        uid: assetUid,
    };
}
export function buildModelAsset(asset) {
    const storageName = createDocumentAssetFilename(asset.filename);
    const assetUid = guid();
    return {
        fileType: "step",
        is3dModel: true,
        isDefault: false,
        isFootprint: false,
        isPcbBoardShape: false,
        isThumbnail: false,
        label: asset.filename,
        name: (asset.filename.split(".").shift() || "") + " Model",
        rawName: asset.filename,
        storageName,
        uid: assetUid,
    };
}
//# sourceMappingURL=helpers.js.map